import React, { Component, useState, useEffect } from "react";
import PriceHighlight from "./PriceHighlight";
import { wsOnReceive, wsSubscribeSymbol, wsUnsuscribeSymbol } from "./IEX";
import style from "./Info.module.scss";
import { debounce } from "../../../../../../utils/Helper";
import MiniLineChart from "./MiniLineChart";

const imgUrl = (value) => `https://storage.googleapis.com/iex/api/logos/${value}.png`;

const chart1dUrl = (value) => `https://api.iextrading.com/1.0/stock/${value}/chart/1d`;

const BoxEquity = ({ value, detailed, items, ...props }) => {
  const [chart, setChart] = useState(null);
  const [price, setPrice] = useState(null);

  useEffect(() => {
    fetch(chart1dUrl(value))
      .then((r) => r.json())
      .then((r) => {
        // ToDo fix IEX call with cloud IEX
        const chart = {
          data: [],
          percent: 0,
        };

        for (let i = 0; i < r.length; i += Math.trunc(r.length / 15)) {
          if (r[i] && r[i].average && r[i].average > 0) {
            chart.data.push(r[i].average);
          }
        }

        if (chart.data.length > 1) {
          const v0 = chart.data[chart.data.length - 2];
          const v1 = chart.data[chart.data.length - 1];

          chart.percent = ((v1 - v0) / v0) * 100;

          setChart(chart);
        }
      })
      .catch((reason) => props.series)
      .then((series) => {
        const chart = { data: [], percent: 0 };

        series.forEach((serie) => {
          chart.data.push(+serie.Price);
        });

        if (chart.data.length > 1) {
          const v0 = chart.data[chart.data.length - 2];
          const v1 = chart.data[chart.data.length - 1];

          chart.percent = ((v1 - v0) / v0) * 100;

          setChart(chart);
        }
      });
  }, [props.series, value]);

  const { provider, description } = props;

  return (
    <div className={style.equity} style={{ minHeight: detailed ? "75px" : "40px" }}>
      <div className={style.description}>
        <img className={style.img} alt="" src={provider == "IEX" ? imgUrl(value) : null} />
        <span>
          {items.AssetName}
          <br />
          <strong>{items.ISIN || "-"}</strong>
        </span>

        {chart && <MiniLineChart data={chart.data} percent={chart.percent} />}

        <span>{provider == "IEX" && price != null ? <strong>{}</strong> : null}</span>
      </div>
      {detailed && (
        <DetailedPrice changePrice={setPrice} value={value} {...props} maxDecimals={items.MaxDecimals} />
      )}
    </div>
  );
};

class DetailedPrice extends Component {
  constructor(props) {
    super(props);

    this.handleChgPriceDebounced = debounce(() => {
      this._isMounted &&
        this.setState({
          data: this.state.data_tmp,
        });
    }, 1000);

    // initialize values from corex
    let initialData = null;
    if (props.series.length > 0) {
      const lastValue = props.series[0];
      initialData = {
        ask: (+lastValue.Open).toFixed(2),
        bid: (+lastValue.Price).toFixed(2),
        last: (+lastValue.Close).toFixed(2),
      };
    }

    this.state = { data: initialData, old: null, loading: true };
  }

  componentDidMount() {
    this._isMounted = true;

    wsOnReceive((data) => {
      this._isMounted &&
        this.setState({
          data_tmp: data,
          loading: false,
          old: this.state.data,
        });

      this.handleChgPriceDebounced();

      this.props.changePrice({ price: data.last });
    });

    wsSubscribeSymbol(this.props.value);
  }

  componentWillUnmount() {
    this._isMounted = false;
    wsUnsuscribeSymbol(this.props.value);
  }

  getValues = (name) => {
    const { data, old } = this.state;

    const getValue = (root, name) => (root == null ? "-" : root[name]);

    return {
      oldValue: getValue(old, name),
      newValue: getValue(data, name),
    };
  };

  render() {
    return (
      <table className={style.tablePrice}>
        <tbody>
          <tr>
            <td style={{ width: "15%" }}>Bid</td>
            <td>
              <PriceHighlight {...this.getValues("bid")} maxDecimals={this.props.maxDecimals} />
            </td>
            <td style={{ width: "15%" }}>Open</td>
            <td>
              <PriceHighlight {...this.getValues("ask")} maxDecimals={this.props.maxDecimals} />
            </td>
          </tr>
          <tr>
            <td>Ask</td>
            <td>
              <PriceHighlight {...this.getValues("ask")} maxDecimals={this.props.maxDecimals} />
            </td>
            <td>Close</td>
            <td>
              <PriceHighlight {...this.getValues("last")} maxDecimals={this.props.maxDecimals} />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default BoxEquity;
